export const calculateLeftDays = (start, end) => {
  let beginDate;
  let today = new Date();
  if (start > today) beginDate = start;
  else beginDate = today;

  let diff = end - beginDate;

  if (diff <= 0) return 0;

  let days = diff / (1000 * 60 * 60 * 24);
  return Math.floor(days);
};

export const convertToISOString = (timestamp) => {
  const date = new Date(timestamp * 1000); // Convert to milliseconds
  const isoString = date.toISOString(); // Convert to ISO 8601 format
  return isoString;
};

export const createTokenExpiredAt = (timestamp) => {
  const date = new Date(timestamp * 1000);
  const year = date.getFullYear();
  const month = ("0" + (date.getMonth() + 1)).slice(-2); // Add leading zero if month is single digit
  const day = ("0" + date.getDate()).slice(-2); // Add leading zero if day is single digit
  const hours = ("0" + date.getHours()).slice(-2); // Add leading zero if hours is single digit
  const minutes = ("0" + date.getMinutes()).slice(-2); // Add leading zero if minutes is single digit

  const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}`;
  return formattedDate;
};

export const createRefreshTokenExpiredAt = (timestamp) => {
  const date = new Date(timestamp * 1000);
  const year = date.getFullYear();
  const month = ("0" + (date.getMonth() + 1)).slice(-2); // Add leading zero if month is single digit
  const day = ("0" + date.getDate()).slice(-2); // Add leading zero if day is single digit
  const hours = ("0" + date.getHours()).slice(-2); // Add leading zero if hours is single digit
  const minutes = ("0" + date.getMinutes()).slice(-2); // Add leading zero if minutes is single digit

  const formattedDate = `${year}${month}${day}${hours}${minutes}`;
  return formattedDate;
};
